import { ApiLocauxService } from './../services/api-locaux.service';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';


@Component({
    selector: 'app-local-byza',
    template: ''
})
export class LocalByZaComponent implements OnInit {
    params;

    constructor(private _activatedRoute: ActivatedRoute, private _apiService: ApiLocauxService, private _router: Router) { 
        this._activatedRoute.params.subscribe((r) => {
            this._apiService.setLocalFormDatas({
                'types': [],
                'superficies': [],
                'avendre': true,
                'alouer': true,
                'territoire': '',
                'commune': '',
                'zone': r.id,
            });

            this._router.navigate(['locaux']);
        });
    }

    ngOnInit() {
    }

   
}



// WEBPACK FOOTER //
// ./src/app/locaux/filter/local-by-za.component.ts